import React from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import Grid from '@material-ui/core/Grid';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import styled from 'styled-components';

import { formatDate } from '../../../utils/constants';
import { useState } from 'react';
import { useEffect } from 'react';
import { getProjects } from '../../../services/projectService';

const QueryForm = ({
  data: report,
  onInputChange,
  onDateChange,
  onSubmit,
  projectId,
}) => {
  const [projects, setProjects] = useState([]);

  const populateProjects = async () => {
    const { data: projects } = await getProjects();
    setProjects(projects);
  };

  useEffect(() => {
    populateProjects();
  }, []);

  return (
    <Grid container justifyContent='space-around' alignItems='center'>
      <GridItem item xs={12}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <DatePicker
            autoOk={true}
            format={formatDate.DATE}
            id='startDate'
            inputVariant='outlined'
            label='Desde *'
            margin='normal'
            maxDate={new Date()}
            onChange={(date) => onDateChange(date, 'startDate')}
            openTo='date'
            size='small'
            style={{
              margin: '1em 1em 1em 0',
            }}
            value={report.startDate}
            variant='outlined'
            views={['year', 'month', 'date']}
          />
          <DatePicker
            autoOk={true}
            disableFuture={true}
            format={formatDate.DATE}
            id='endDate'
            inputVariant='outlined'
            label='Hasta *'
            margin='normal'
            minDate={report.startDate}
            onChange={(date) => onDateChange(date, 'endDate')}
            openTo='date'
            size='small'
            style={{
              margin: '1em 1em 1em 0',
            }}
            value={report.endDate}
            variant='outlined'
            views={['year', 'month', 'date']}
          />
        </MuiPickersUtilsProvider>
        <FormControl
          variant='outlined'
          fullWidth
          size='small'
          style={{ width: '20em', marginRight: '1em' }}
        >
          <InputLabel id='projectSlug'>Seleccione un proyecto</InputLabel>
          <Select
            name='projectId'
            value={projectId}
            onChange={onInputChange}
            labelWidth={180}
          >
            <MenuItem value='all' key='all' selected>
              Todos
            </MenuItem>
            {projects.map((project) => (
              <MenuItem value={project.id} key={project.id}>
                {project.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={onSubmit}
          color='primary'
          variant='contained'
          margin='normal'
          size='medium'
        >
          Buscar informes
        </Button>
      </GridItem>
    </Grid>
  );
};

const GridItem = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: '100%';
`;

export default QueryForm;
